<template>
    <!-- ##### Input match result Modal ##### -->
    <!-- <form class="col-auto"> -->
        <div class="modal fade modal-dialog-scrollable" id="inputMatchResultModal" tabindex="-1"
            aria-labelledby="inputMatchResultModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="inputMatchResultModalLabel">試合状況・結果登録</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" tabindex="-1"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label class="col-5 form-label px-1">試合番号:</label>
                            <div class="col-7"><span style="color:red; font-weight: 800">{{ selectedMatchKey }}</span>
                            </div>
                        </div>
                        <div class="row mb-0">
                            <table class="table table-bordered align-middle my-1 py-1">
                                <tbody>
                                <tr>
                                    <td class="text-center" style="border-right: 0; width: 15%;">
                                        <TeamLabelComponent :teamId="selectedMatch.left_team_id_1"/><br><TeamLabelComponent :teamId="selectedMatch.left_team_id_2" v-if="selectedMatch.left_team_id_2 != '' && selectedMatch.left_team_id_1 != selectedMatch.left_team_id_2"/>
                                    </td>
                                    <td style="border-left: 0;border-right: 0; width: 30%;">
                                        {{ selectedMatch.left_player_name_1 }}<br>{{ selectedMatch.left_player_name_2 }}
                                    </td>
                                    <td class="text-center" style="border-left: 0;border-right: 0; width: 10%;">vs.</td>
                                    <td class="text-center" style="border-left: 0;border-right: 0; width: 30%;">
                                        {{ selectedMatch.right_player_name_1 }}<br>{{ selectedMatch.right_player_name_2 }}
                                    </td>
                                    <td style="border-left: 0; width: 15%;">
                                        <TeamLabelComponent :teamId="selectedMatch.right_team_id_1"/><br><TeamLabelComponent :teamId="selectedMatch.right_team_id_2" v-if="selectedMatch.right_team_id_2 != '' && selectedMatch.right_team_id_1 != selectedMatch.right_team_id_2"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table class="table table-bordered align-middle my-1 py-1">
                                <tbody>
                                <tr class="text-center">
                                    <td style="background-color: lightgray; height:10px;" class="m-0 p-0" colspan="4"><span style="font-size: 9pt;">状況</span></td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <label>
                                            <input type="radio" name="match_status" id="status_waiting" value="waiting" v-model="selectedMatch.match_status"/><br/>
                                            <span :class="{ 'fw-bold': selectedMatch.match_status === 'waiting' }" :style="{ color: selectedMatch.match_status === 'waiting' ? 'black' : 'slategray' }"> 待　機</span>
                                        </label>
                                    </td>
                                    <td class="text-center" style="background-color: cornsilk;">
                                        <label>
                                            <input type="radio" name="match_status" id="status_called" value="called" v-model="selectedMatch.match_status"/><br/>
                                            <span :class="{ 'fw-bold': selectedMatch.match_status === 'called' }" :style="{ color: selectedMatch.match_status === 'called' ? 'black' : 'slategray' }"> 招集中</span>
                                        </label>
                                    </td>
                                    <td class="text-center" style="background-color: aliceblue;">
                                        <label>
                                            <input type="radio" name="match_status" id="status_playing" value="playing" v-model="selectedMatch.match_status"/><br/>
                                            <span :class="{ 'fw-bold': selectedMatch.match_status === 'playing' }" :style="{ color: selectedMatch.match_status === 'playing' ? 'black' : 'slategray' }"> 試合中</span>
                                        </label>
                                    </td>
                                    <td class="text-center">
                                        <label>
                                            <input type="radio" name="match_status" id="status_finished" value="finished" v-model="selectedMatch.match_status"/><br/>
                                            <span :class="{ 'fw-bold': selectedMatch.match_status === 'finished' }" :style="{ color: selectedMatch.match_status === 'finished' ? 'black' : 'slategray' }"> 終　了</span>
                                        </label>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table class="table table-bordered align-middle my-1 py-1">
                                <tbody>
                                <tr class="text-center">
                                    <td style="background-color: lightgray; height:10px;" class="m-0 p-0"><span style="font-size: 9pt;">勝者</span></td>
                                    <td style="background-color: lightgray; height:10px;" class="m-0 p-0" colspan="3"><span style="font-size: 9pt;">ゲーム・スコア</span></td>
                                    <td style="background-color: lightgray; height:10px;" class="m-0 p-0"><span style="font-size: 9pt;">勝者</span></td>
                                </tr>
                                <tr>
                                    <td class="text-center" style="border-right: 0; background-color: whitesmoke;" rowspan="3"><input type="radio" name="winner" tabindex="3" v-model="selectedMatch.winner_entry_id" :value="selectedMatch.left_entry_id">&nbsp;</td>
                                    <td class="text-center" style="border-left: 0;"><input type="number" style='width: 43px;' tabindex="5" id="left_player_score" v-model="selectedMatch.left_game1_score"></td>
                                    <td class="text-center" style="border-right: 0; background-color: whitesmoke; width: 15%;"><span style="font-size: 10pt;">1st</span></td>
                                    <td class="text-center" style="border-right: 0;"><input type="number" style='width: 43px;' tabindex="6" v-model="selectedMatch.right_game1_score"></td>
                                    <td class="text-center" style="border-left: 0; background-color: whitesmoke;" rowspan="3"><input type="radio" name="winner" tabindex="4" v-model="selectedMatch.winner_entry_id" :value="selectedMatch.right_entry_id"></td>
                                </tr>
                                <tr>
                                    <!-- <td class="text-center" style="border-right: 0; background-color: whitesmoke;"></td> -->
                                    <td class="text-center" style="border-left: 0;"><input type="number" style='width: 43px;' tabindex="7" id="left_player_score" v-model="selectedMatch.left_game2_score"></td>
                                    <td class="text-center" style="border-right: 0; background-color: whitesmoke; width: 15%;"><span style="font-size: 10pt;">2nd</span></td>
                                    <td class="text-center" style="border-right: 0;"><input type="number" style='width: 43px;' tabindex="8" v-model="selectedMatch.right_game2_score"></td>
                                    <!-- <td class="text-center" style="border-left: 0; background-color: whitesmoke;"></td> -->
                                </tr>
                                <tr>
                                    <!-- <td class="text-center" style="border-right: 0; background-color: whitesmoke;"></td> -->
                                    <td class="text-center" style="border-left: 0;"><input type="number" style='width: 43px;' tabindex="9" id="left_player_score" v-model="selectedMatch.left_game3_score"></td>
                                    <td class="text-center" style="border-right: 0; background-color: whitesmoke; width: 15%;"><span style="font-size: 10pt;">Final</span></td>
                                    <td class="text-center" style="border-right: 0;"><input type="number" style='width: 43px;' tabindex="10" v-model="selectedMatch.right_game3_score"></td>
                                    <!-- <td class="text-center" style="border-left: 0; background-color: whitesmoke;"></td> -->
                                </tr>
                                </tbody>
                            </table>
                            <table class="table table-bordered align-middle my-1 py-1">
                                <tbody>
                                <tr class="text-center">
                                    <td style="background-color: lightgray; height:10px;" class="m-0 p-0"><span style="font-size: 9pt;">お知らせ</span></td>
                                </tr>
                                <tr class="text-center">
                                    <td><input type="text" v-model="selectedMatch.note" style="width: 280px;" tabindex="11"></td>
                                </tr>
                                </tbody>
                            </table>

                            
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div>
                            <span>
                                <button type="button" class="btn btn-secondary" tabindex="12" data-bs-dismiss="modal">戻る</button>&nbsp;
                                <button type="button" class="btn btn-outline-primary filter-btn filter-reset-btn"
                                    @click="clearInputClicked" id="clear-button" tabindex="13">クリア</button>&nbsp;
                                <button type="button" class="btn btn-primary" tabindex="14" @click="saveMatchScore" data-bs-dismiss="modal">保存する</button>
                            </span>
                        </div>
                        <div>
                            <span v-if="errorMessage" style="color: red"><br>{{ errorMessage }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!-- </form> -->
    <!-- ##### End of Form ##### -->

    <div class="text-center" v-if="isLoading">
        <div class="spinner-border spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick, watch } from 'vue';
import { getAuth } from "firebase/auth";
import { ref as fbRef, getDatabase, child, get, onValue, onlyOnce, update, equalTo, query, orderByChild } from "firebase/database"
import { routeLocationKey } from 'vue-router';
import TeamLabelComponent from './TeamLabelComponent.vue';

const auth = getAuth();
const user = auth.currentUser;
// const role = ref();

const match = ref([])
const db = getDatabase();
const dbRef = fbRef(db);

const props = defineProps(['selectedMatchKey', 'selectedMatch']);
const emit = defineEmits(["doReload"])

const isLoading = ref()

const errorMessage = ref()

// 勝者選択の変更を監視
watch(() => props.selectedMatch.winner_entry_id, (newValue) => {
    // 勝者が選択された場合
    if (newValue) {
        props.selectedMatch.match_status = 'finished'
    } 
})

// 試合ステータスの変更を監視
watch(() => props.selectedMatch.match_status, (newValue) => {
    // waiting, called, playingの場合は勝者をクリア
    if (newValue === 'waiting' || newValue === 'called' || newValue === 'playing') {
        props.selectedMatch.winner_entry_id = null
    }
})

onMounted(() => {
    // user.getIdTokenResult()
    // .then((idTokenResult) => {
    //     role.value = idTokenResult.claims.role;
    // })
});

const saveMatchScore = async () => {
    if (user && user.email) {
        isLoading.value = ref(true);
        const updates = {};
        updates['/2026-summer/matches/' + props.selectedMatchKey] = props.selectedMatch;
        await update(dbRef, updates)
        .then(async () => {
            console.log("Updated match:" + props.selectedMatchKey)
        }).catch((error) => {
            errorMessage.value = error
            console.log(error)
        // 以下はfunctionsで行うので不要
        // }).then(async () => {
        //     if (isTournament(props.selectedMatch.event_id)) {
        //         await setNextMatchPlayer(props.selectedMatch.event_id, props.selectedMatch.winner_entry_id, props.selectedMatch.match_no);
        //     }
        }).finally(async () => {
            isLoading.value = false;
        });
        
    }
}

const isLeague = (event_id) => {
    return (getEventMethod(event_id) == "リーグ");
}

const isTournament = (event_id) => {
    return (getEventMethod(event_id) == "トーナメント");
}

const getEventMethod = (event_id) => {
    const allEvents = JSON.parse(localStorage.getItem("events"));
    const selectedEvent = ref([]);
    selectedEvent.value = allEvents;
    selectedEvent.value = Object.fromEntries(
        Object.entries(selectedEvent.value).filter(([key, value]) =>
        (event_id == value.event_id))
    );
    return selectedEvent.value[event_id].method;
}

const setNextMatchPlayer = async (winner_event_id, winner_entry_id, previous_match_no) => {
    // console.log("setNextMatchPlayer\n winner_event_id:" + winner_event_id)
    // console.log("winner_entry_id:" + winner_entry_id)
    // console.log("previous_match_no:" + previous_match_no)
    const is_reset = ref(false);
    if (!winner_entry_id || winner_entry_id == "") {
        is_reset.value = true;
    }

    // const allEvents = JSON.parse(localStorage.getItem("events"));
    // const tournamentEvent = ref([]);
    // tournamentEvent.value = allEvents;

    // tournamentEvent.value = Object.fromEntries(
    //     Object.entries(tournamentEvent.value).filter(([key, value]) =>
    //     (winner_event_id == value.event_id))
    // );

    // const tournamentEventJson = JSON.stringify(tournamentEvent.value);
    // if (tournamentEvent.value[winner_event_id] != null && tournamentEvent.value[winner_event_id].method == "トーナメント") {
        // const matchesRef = fbRef(db, '/2026-summer/matches/');
        // const queryRef = query(matchesRef, orderByChild('event_id'), equalTo('6MTa'));
        // const myVal = ref([])
        // get(queryRef)
        // .then((snapshot) => {
        //     console.log("aa" + JSON.stringify(snapshot.val()))
        //     myVal.value = "snapshot.val()"
        // });

        // console.log("bbb")
        // console.log(JSON.stringify(myVal.value))
        // エントリーを取得
        const entry = ref([]);
        entry.value = getWinnerEntry(winner_event_id, winner_entry_id);

        // 次の試合を検索
        const allMatches = JSON.parse(localStorage.getItem("matches"));
        const nextMatch = ref([]);
        nextMatch.value = allMatches;
        const next_match_entry_id = "win-" + winner_event_id + "-" + previous_match_no; // e.g., win-6MTa-1
        nextMatch.value = Object.fromEntries(
            Object.entries(nextMatch.value).filter(([key, value]) =>
            ((winner_event_id == value.event_id) && (next_match_entry_id == value.left_entry_id || next_match_entry_id == value.right_entry_id)))
        );
        const next_match_key = Object.keys(nextMatch.value)[0];
        // console.log("Next match: " + JSON.stringify(nextMatch.value))

        // 次の試合の選手名を更新
        const next_match = ref([]);
        await get(child(dbRef, '/2026-summer/matches/' + next_match_key))
            .then(async (snapshot) => {
                if (snapshot.exists()) {
                    next_match.value = snapshot.val();
                    if (nextMatch.value[next_match_key].left_entry_id == next_match_entry_id) {
                        if (!is_reset.value) {
                            next_match.value.left_player_name_1 = entry.value.player_name_1;
                            next_match.value.left_player_name_2 = entry.value.player_name_2;
                            next_match.value.left_team_id_1 = entry.value.team_id_1;
                            next_match.value.left_team_id_2 = entry.value.team_id_2;
                        } else {
                            next_match.value.left_player_name_1 = "";
                            next_match.value.left_player_name_2 = "";
                            next_match.value.left_team_id_1 = "";
                            next_match.value.left_team_id_2 = "";
                        }
                        // console.log("update left - " + JSON.stringify(next_match.value))
                    }
                    if (nextMatch.value[next_match_key].right_entry_id == next_match_entry_id) {
                        if (!is_reset.value) {
                            next_match.value.right_player_name_1 = entry.value.player_name_1;
                            next_match.value.right_player_name_2 = entry.value.player_name_2;
                            next_match.value.right_team_id_1 = entry.value.team_id_1;
                            next_match.value.right_team_id_2 = entry.value.team_id_2;
                        } else {
                            next_match.value.right_player_name_1 = "";
                            next_match.value.right_player_name_2 = "";
                            next_match.value.right_team_id_1 = "";
                            next_match.value.right_team_id_2 = "";
                        }
                        // console.log("update right - " + JSON.stringify(next_match.value))
                    }
                    const updates = {};
                    updates['/2026-summer/matches/' + next_match_key] = next_match.value;
                    await update(dbRef, updates)
                    .then(async () => {
                            console.log("Next match(" + next_match_key + ") player was set succssfully.")
                        })
                        .catch((error) => {
                            console.error(error)
                            throw(error)
                        });
                }
            }).catch((error) => {
                errorMessage.value = error
                console.error(error)
            })
        // console.log(entry.value[winner_event_id + "-" + winner_entry_id].player_name_1)


    // } else {
    //     // console.log("doesn't exist in events as a tournament - winner_event_id:" + winner_event_id)
    // }
}

/* 
 * event_id=5NTa, winner_entry_id=win-5NTa-1 or 1
 */
const getWinnerEntry = (event_id, winner_entry_id) => {
    const entryId = ref([]);
    // Originalのentry_idを再帰的に探す
    //     前の試合のwinner_entry_idを取得
    //     その試合がwin-で始まる場合は、またさらに遡る
    entryId.value = getOriginalEntryId(event_id, winner_entry_id);
    // console.log(entryId.value)
        
    // entry_idが1,8,11のような数字で見つかった場合
    // entries.jsonから取得する
    const allEntries = ref([])
    allEntries.value = JSON.parse(localStorage.getItem("entries"));
    const entry = ref();
    entry.value = allEntries.value[event_id + "-" + entryId.value];
    // console.log(entry.value);

    return entry.value;
}

const getOriginalEntryId = (event_id, winner_entry_id) => {
    if (winner_entry_id.toString().startsWith("win-")) {
        const match_key = ref();
        match_key.value = winner_entry_id.substring(4, winner_entry_id.length);
        const allMatches = ref([])
        allMatches.value = JSON.parse(localStorage.getItem("matches"));
        // console.log("prevMatch>>")
        // console.log(prevMatch.value);
        // console.log(prevMatch.value[match_key.value].winner_entry_id)
        return getOriginalEntryId(event_id, allMatches.value[match_key.value].winner_entry_id);
    } else {
        return winner_entry_id;
    }
}

const clearInputClicked = () => {
    let elements = document.getElementsByName("winner");
    for (let i = 0; i < elements.length; i++) {
        elements[i].checked = false;
    }
    props.selectedMatch.right_score = ""
    props.selectedMatch.left_score = ""
    props.selectedMatch.winner_entry_id = ""
    props.selectedMatch.match_status = "waiting"
    props.selectedMatch.left_game1_score = ""
    props.selectedMatch.left_game2_score = ""
    props.selectedMatch.left_game3_score = ""
    props.selectedMatch.right_game1_score = ""
    props.selectedMatch.right_game2_score = ""
    props.selectedMatch.right_game3_score = ""
    props.selectedMatch.note = ""
    // document.getElementById("left_score").value = ""
    // document.getElementById("right_score").value = ""
    setTimeout(function() {
        document.getElementById("clear-button").blur();
        document.getElementById("left_player_score").focus();
    });

}

</script>

<style scoped>

.spinner {
  position: fixed;
  left: 50%;
  top: 20%;
  margin: 0px auto;
  z-index: 999;
}
</style>